import React, { memo } from 'react';
import { Route, Routes } from 'react-router-dom';

import ThemeButtons from '../components/theme/ThemeButtons';
import HeaderColumn from './components/header-column/HeaderColumn';
import UserProfile from './components/user-profile/UserProfile';
import AllProjectButton from './components/projects/AllProjectButton';
import MultipleRoute from '../components/multiple-route/MultipleRoute';
import { APP_HEADER_ACTION_ROUTES, APP_HEADER_PRIMARY_ROUTES } from './appHeaderRoutes';

import './Header.scss';

const Header = () => {
  return (
    <header className='header'>
      <Routes>
        {APP_HEADER_PRIMARY_ROUTES.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Routes>

      <HeaderColumn>
        <Routes>
          {APP_HEADER_ACTION_ROUTES.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Routes>
        <MultipleRoute paths={['/projects/create/*', '/projects/edit/*']} element={<AllProjectButton />} />

        <div className='header_user-block'>
          <div className='theme-switch-wrapper'>
            <ThemeButtons />
          </div>

          <UserProfile />
        </div>
      </HeaderColumn>
    </header>
  );
};

export default memo(Header);
